import { templates as addons } from "./components/Addons";
import { templates as layouts } from "./components/Layout";

const templates = [
    ...layouts,
    ...addons,
];

export default templates;